import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs';

import { NgCommService } from '../../ajs-ng-communication.service';
import { AjsScopeService } from '../../ajs-scope.service';
import { AjsStateService } from '../../ajs-state.service';
import { states } from '../application.states';
import {
	goToGdHome,
	goToHdHome,
	goToProjects,
	setCurrentUserId,
	setUserAdminRole,
} from './app.actions';

@Injectable()
export class AppEffects {
	public userIsAdmin$ = createEffect(() =>
		this.ajsScopeService.listenOnRootScope<boolean>('sync:user:is-admin').pipe(
			map((val) =>
				setUserAdminRole({
					isAdmin: val,
				})
			)
		)
	);

	public connectedUserId$ = createEffect(() =>
		this.ajsScopeService.listenOnRootScope<string>('sync:user:id').pipe(
			map((val) =>
				setCurrentUserId({
					userId: val,
				})
			)
		)
	);

	public redirectHome$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType('redirect:home'),
				tap(() =>
					this.ngCommService.notifyOnWarning(
						$localize`:i18n=@@general.project.invalid:`
					)
				)
			),
		{
			dispatch: false,
		}
	);

	public hdHomePage$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(goToHdHome),
				tap(() => this.stateService.go(states.HdHome))
			),
		{
			dispatch: false,
		}
	);

	public gdHomePage$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(goToGdHome),
				tap(() => this.stateService.go(states.GdHome))
			),
		{
			dispatch: false,
		}
	);

	public projectsPage$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(goToProjects),
				tap(() => this.stateService.go(states.Projects))
			),
		{
			dispatch: false,
		}
	);

	// TODO: translate title keys
	public setTitleOnTransitionSuccess$ = createEffect(
		() =>
			this.ajsScopeService
				.listenOnRootScope<string>('state:transition:success')
				.pipe(tap((v) => this.titleService.setTitle(`Datachain - ${v}`))),
		{
			dispatch: false,
		}
	);

	public constructor(
		private readonly actions$: Actions,
		private readonly titleService: Title,
		private readonly ajsScopeService: AjsScopeService,
		private readonly stateService: AjsStateService,
		private readonly ngCommService: NgCommService
	) {}
}
